import styled from 'styled-components';

export const Title = styled.h1`
  font-size: ${props => props.theme.fontSizePrimary};
  color: black;
`;
